import Header from './header';
import { Form } from './form';
import { Calendar } from './Calendar';
import { RoomSlider } from './RoomSlider';
import { Carousel } from './carousel';
import { handleHeroArrowClick } from './helpers';
import { Model } from './Model';
import { initMap } from './map';

export class Controller {
	constructor() {
		this.headerRoot = document.querySelector('#header');
		this.formRoot = document.querySelector('#form');
		this.footerDateSpan = document.querySelector('#footerDate');
		this.calendarRoot = document.querySelector('#calendar');
		this.carouselRoot = document.querySelector('#carousel');
		this.roomSliderRoot = document.querySelector('#roomSlider');
		this.photos = document.querySelectorAll('#photosImg');
		this.heroArrow = document.querySelector('#heroArrow');
		this.map = document.querySelector('#map');
		this._init();
	}

	_init() {
		if (this.firstScrolls) this._initAppearOnLoadScroll(this.firstScrolls);
		if (this.headerRoot) this._initHeader(this.headerRoot);
		if (this.footerDateSpan) this._initFooter(this.footerDateSpan);
		if (this.calendarRoot) this._initCalendar(this.calendarRoot);
		if (this.formRoot) this._initForm(this.formRoot);
		if (this.roomSliderRoot) this._initRoomSlider(this.roomSliderRoot);
		if (this.carouselRoot) this._initCarousel(this.carouselRoot);
		if (this.heroArrow) this._initHeroArrow(this.heroArrow);
		if (this.map) initMap(this.map);
	}

	_initHeader = root => new Header(root);

	_initCarousel = root => new Carousel(root, 4, 'carousel');

	_initRoomSlider = root => new RoomSlider(root);

	_initHeroArrow(root) {
		root.addEventListener('click', handleHeroArrowClick);
	}

	_initFooter(root) {
		const currYear = new Date().getFullYear();
		root.innerHTML = currYear;
	}

	_initCalendar(root) {
		this.Calendar = new Calendar(root);
		if (!this.Calendar.isPermanent()) return;
		this.setCalendarData(this.Calendar.getApartmentId());
	}

	_initForm(root) {
		Model.initForm();
		this.Form = new Form(root, this.handleSendForm, {
			changeCalendar: this.setCalendarData,
			calcBookingRange: this.calcBookingRange,
		});
	}

	handleSendForm = async form => {
		this.Form.resetErrors();
		this.Form.loading();
		try {
			await Model.sendForm(form);
			this.Form.confirmSend();
		} catch (err) {
			this.Form.alertSendError();
		}
	};

	setCalendarData = async id => {
		if (!this.Calendar) return;
		this.Calendar.setLoading();
		try {
			const data = await Model.getCalendarData(id);
			this.Calendar.displayData(data);
			return data;
		} catch (err) {
			console.error(err);
			const errorBtn = this.Calendar.error(err);
			errorBtn.addEventListener('click', () => this.setCalendarData(id));
		}
	};
}
